import { adminHttpClient } from '../../../commons/adminHttpClient'
import { Moment } from 'moment'

export interface UserToTerminate {
  employeeId: string
  fullName: string
  terminationDate: Moment
  planPeriodStartDate?: string
}

const terminateEmployee = (userToTerminate: UserToTerminate): Promise<any> => {
  return adminHttpClient.put('/AdminDashboard/ManagePeople/TerminateUser', {
    employeeId: userToTerminate.employeeId,
    terminationDate: userToTerminate.terminationDate,
  })
}

export default terminateEmployee
